<script lang="ts">
    import MainLayout from "../#common/layout/Layout.svelte"
    import IconifyIcon from '@iconify/svelte'
    import usersIcon from '@iconify/icons-fa-solid/users'
    import coinsIcon from '@iconify/icons-fa-solid/coins'
    import wifiIcon from '@iconify/icons-fa-solid/wifi'
    import dollarIcon from '@iconify/icons-fa-solid/dollar-sign';
    import chartIcon from '@iconify/icons-fa-solid/chart-line';
    import shoppingBag from '@iconify/icons-fa-solid/shopping-bag'
    import moment from 'moment';
    import {audience, userBalances, getCountActives} from 'src/components/cabinet/#services/dashboard'
    import Main from "../analytics/components/merge/Main.svelte";
    import { Link } from "svelte-routing";
    import { getDashboardAnalytics } from "../#services/dashboardAnalytics";
    import { getActivityAnalytics, getRetentionAnalytics } from "../#services/retentionAnalytics";
    import { requestData } from "./requestData";

    audience.reset()
    audience.send()
    userBalances.reset()
    userBalances.send()
    getCountActives.reset()
    getCountActives.send()

    // avg retention of 7 day

    const avgRetentionStartDate = moment().subtract(14, 'days');
    const avgRetentionDates: { start: string, end: string }[] = [];

    for (let i = 0; i < 7; i++) {
        avgRetentionDates.push({ start: avgRetentionStartDate.clone().add(i, 'days').format('YYYY-MM-DD'), end: avgRetentionStartDate.clone().add(i + 7, 'days').format('YYYY-MM-DD') }, );
    }

    // avg retention of 7 day end

    // avg retention of 1 day

    const avgRetentionFirstDayStartDate = moment().subtract(8, 'days');
    const avgRetentionFirstDayDates: { start: string, end: string }[] = [];

    for (let i = 0; i < 7; i++) {
        avgRetentionFirstDayDates.push({ start: avgRetentionFirstDayStartDate.clone().add(i, 'days').format('YYYY-MM-DD'), end: avgRetentionFirstDayStartDate.clone().add(i + 1, 'days').format('YYYY-MM-DD') }, );
    }

    // avg retention of 1 day end

    let activityStartDate = moment().subtract(14, 'days').format('YYYY-MM-DD');
    let retentionStartDate = moment().subtract(11, 'days').format('YYYY-MM-DD');
    const retentionEndDate = moment().subtract(1, 'days').format('YYYY-MM-DD');

    getRetentionAnalytics.reset()
    getRetentionAnalytics.send({
        data: {
            branches: [
                {
                    label: 'Cats',
                    appId: 3,
                },
                {
                    label: 'Dragons',
                    appId: 5,
                },
                {
                    label: 'Foxes',
                    appId: 7,
                },
                {
                    label: 'Dogs',
                    appId: 11,
                },
            ],
            startDate: retentionStartDate,
            endDate: retentionEndDate,
        },
    })

    getActivityAnalytics.reset()
    getActivityAnalytics.send({
        data: {
            branches: [
                {
                    label: 'Previous',
                    startDate: activityStartDate,
                    endDate: moment(activityStartDate).add(6, 'days').format('YYYY-MM-DD'),
                },
                {
                    label: 'Current',
                    startDate: moment(activityStartDate).add(7, 'days').format('YYYY-MM-DD'),
                    endDate: moment(activityStartDate).add(13, 'days').format('YYYY-MM-DD'),
                }
            ],
        }
    })

    let activity = {
        [3]: 0,
        [5]: 0,
        [7]: 0,
        [11]: 0,
    };

    let previousActivity = {
        [3]: 0,
        [5]: 0,
        [7]: 0,
        [11]: 0,
    };

    let globalActivity = {
        'Current': 0,
        'Previous': 0,
    };

    getActivityAnalytics.subscribe((value) => {
        if (value.hasValue && !value.error && !value.loading) {
            value.value.result.forEach((data, idx) => {
                if (data.label === 'Previous') {
                    if (data.appId) {
                        previousActivity[data.appId] = +data.activity;
                    } else {
                        globalActivity['Previous'] = +data.activity;
                    }
                } else if (data.label === 'Current') {
                    if (data.appId) {
                        activity[data.appId] = +data.activity;
                    } else {
                        globalActivity['Current'] = +data.activity;
                    }
                }
            });
        }
    });

    getDashboardAnalytics.reset()
    getDashboardAnalytics.send({
        data: {
            branches: [
                ...requestData,
                ...(avgRetentionDates.map(({start, end}, idx) => ({
                    key: `avgRetention${idx}`,
                    retention: {
                        branches: [
                            {
                                label: 'Cats',
                                appId: 3,
                            },
                            {
                                label: 'Dragons',
                                appId: 5,
                            },
                            {
                                label: 'Foxes',
                                appId: 7,
                            },
                            {
                                label: 'Dogs',
                                appId: 11,
                            }
                        ],
                        onlyNewUsers: true,
                        startDate: start,
                        endDate: end,
                    }
                }))),
                ...(avgRetentionFirstDayDates.map(({start, end}, idx) => ({
                    key: `avgRetentionFirstDay${idx}`,
                    retention: {
                        branches: [
                            {
                                label: 'Cats',
                                appId: 3,
                            },
                            {
                                label: 'Dragons',
                                appId: 5,
                            },
                            {
                                label: 'Foxes',
                                appId: 7,
                            },
                            {
                                label: 'Dogs',
                                appId: 11,
                            }
                        ],
                        onlyNewUsers: true,
                        startDate: start,
                        endDate: end,
                    }
                }))),
            ],
        },
    });

    const avgRetention = { // avg retention of 7 day
        Cats: '',
        Dragons: '',
        Foxes: '',
        Dogs: '',
    };

    const avgRetentionFirstDay = { // avg retention of 1 day
        Cats: '',
        Dragons: '',
        Foxes: '',
        Dogs: '',
    };
    
    getDashboardAnalytics.subscribe((response) => {
        if (response.hasValue && !response.error && !response.loading) {
            const labels = ['Cats', 'Dragons', 'Foxes', 'Dogs'];

            for (const label of labels) {
                let sumOfFirstDay = 0;
                let sumOfLastDay = 0;
                for (let i = 0; i < 7; i++) {
                    sumOfFirstDay += response.value.data[`retention_avgRetention${i}_${label}`].extraDetails.uniqueFirstDay;
                    sumOfLastDay += response.value.data[`retention_avgRetention${i}_${label}`].extraDetails.returnedLastDayFromZeroDay[response.value.data[`retention_avgRetention${i}_${label}`].extraDetails.returnedLastDayFromZeroDay.length - 1];
                }

                avgRetention[label] = (sumOfLastDay / sumOfFirstDay * 100).toFixed(2);
            }

            for (const label of labels) {
                let sumOfFirstDay = 0;
                let sumOfLastDay = 0;
                for (let i = 0; i < 7; i++) {
                    sumOfFirstDay += response.value.data[`retention_avgRetentionFirstDay${i}_${label}`].extraDetails.uniqueFirstDay;
                    sumOfLastDay += response.value.data[`retention_avgRetentionFirstDay${i}_${label}`].extraDetails.returnedLastDayFromZeroDay[0];
                }

                avgRetentionFirstDay[label] = (sumOfLastDay / sumOfFirstDay * 100).toFixed(2);
            }
        }
    });
</script>

<svelte:head>
    <title>Dashboard</title>
</svelte:head>

<MainLayout title="Dashboard">
    <svelte:fragment slot="content">
        <div class="row">

            <div class="col-lg-6 col-xxl-4">
                <div class="card widget-flat">
                    <div class="card-body">
                        <div class="float-end">
                            <div class="widget-icon">
                                <IconifyIcon icon={usersIcon}/>
                            </div>
                        </div>
                        <h6 class="text-muted fw-normal mt-0" title="Users">Users</h6>
                        <h3 class="mt-3 mb-2">
                            <span class:loading={$audience.loading} class:audience-loading={$audience.loading}>
                                {$audience.value ? $audience.value.toLocaleString() : ""}
                            </span>
                        </h3>
                    </div>
                </div>
            </div>

            <div class="col-lg-6 col-xxl-4">
                <div class="card widget-flat">
                    <div class="card-body">
                        <div class="float-end">
                            <div class="widget-icon">
                                <IconifyIcon icon={coinsIcon}/>
                            </div>
                        </div>
                        <h6 class="text-muted fw-normal mt-0" title="LIS on balance">LIS on balance</h6>
                        <h3 class="mt-3 mb-2">
                            <span class:loading={$userBalances.loading} class:audience-loading={$userBalances.loading}>
                                {$userBalances.value ? $userBalances.value.toLocaleString() : ""}
                            </span>
                        </h3>
                    </div>
                </div>
            </div>

            <div class="col-lg-6 col-xxl-4">
                <div class="card widget-flat">
                    <div class="card-body">
                        <div class="float-end">
                            <div class="widget-icon">
                                <IconifyIcon icon={wifiIcon}/>
                            </div>
                        </div>
                        <h6 class="text-muted fw-normal mt-0" title="Active users">Active users</h6>
                        <h3 class="mt-3 mb-2">
                            <span class:loading={$getCountActives.loading} class:audience-loading={$getCountActives.loading}>
                                {$getCountActives.value ? $getCountActives.value.toLocaleString() : ""}
                            </span>
                        </h3>
                    </div>
                </div>
            </div>

            <div class="col-xxl-12"><h6 class="section-title">Weekly analytics</h6></div>

            <div class="col-lg-6 col-xxl-3">
                <div class="card widget-flat">
                    <div class="card-body">
                        <div class="float-end">
                            <div class="widget-icon">
                                <IconifyIcon icon={coinsIcon}/>
                            </div>
                        </div>
                        <h6 class="text-muted fw-normal mt-0">Free rewards</h6>
                        <h3 class="mt-3 mb-2">
                             <span class:loading={$getDashboardAnalytics.loading} class:audience-loading={$getDashboardAnalytics.loading}>
                                 {$getDashboardAnalytics.value ? `${Math.trunc((Math.abs($getDashboardAnalytics.value.data.free) + $getDashboardAnalytics.value.data.freeMathRewards)).toLocaleString()}` : ""}
                                 <span class="currency" class:dn={$getDashboardAnalytics.loading}>LIS</span>
                             </span>
                            {#if $getDashboardAnalytics.value && (Math.abs($getDashboardAnalytics.value.data.free) + $getDashboardAnalytics.value.data.freeMathRewards) !== 0 && (Math.abs($getDashboardAnalytics.value.data.freePreviousWeek) - $getDashboardAnalytics.value.data.freePreviousWeekMathRewards) !== 0}
                            <br><span class="small red" class:loading={$getDashboardAnalytics.loading} class:audience-loading={$getDashboardAnalytics.loading} class:green={(Math.abs($getDashboardAnalytics.value.data.freePreviousWeek) + $getDashboardAnalytics.value.data.freePreviousWeekMathRewards) < (Math.abs($getDashboardAnalytics.value.data.free) + $getDashboardAnalytics.value.data.freeMathRewards)}>
                                    {$getDashboardAnalytics.value ? `${(Math.abs($getDashboardAnalytics.value.data.freePreviousWeek) + $getDashboardAnalytics.value.data.freePreviousWeekMathRewards) < (Math.abs($getDashboardAnalytics.value.data.free) + $getDashboardAnalytics.value.data.freeMathRewards) ? '+' : ''}${((Math.abs($getDashboardAnalytics.value.data.free) + $getDashboardAnalytics.value.data.freeMathRewards) * 100 / (Math.abs($getDashboardAnalytics.value.data.freePreviousWeek) + $getDashboardAnalytics.value.data.freePreviousWeekMathRewards) - 100).toFixed(1)} %` : ""}
                                </span>
                            {/if}
                        </h3>
                    </div>
                </div>
            </div>
            
            <div class="col-lg-6 col-xxl-3">
                <div class="card widget-flat">
                    <div class="card-body">
                        <div class="float-end">
                            <div class="widget-icon">
                                <IconifyIcon icon={chartIcon}/>
                            </div>
                        </div>
                        <h6 class="text-muted fw-normal mt-0">Mem. payback(purch-rew)</h6>
                        <h3 class="mt-3 mb-2">
                             <span class:loading={$getDashboardAnalytics.loading} class:audience-loading={$getDashboardAnalytics.loading}>
                                 {$getDashboardAnalytics.value ? `${Math.trunc($getDashboardAnalytics.value.data.memberships + $getDashboardAnalytics.value.data.googlePlayMemberships - $getDashboardAnalytics.value.data.questsRewards).toLocaleString()}` : ""}
                                 <span class="currency" class:dn={$getDashboardAnalytics.loading}>LIS</span>
                                 <span class="memberships-payback" class:dn={$getDashboardAnalytics.loading}>{$getDashboardAnalytics.value ? `${Math.trunc($getDashboardAnalytics.value.data.memberships + $getDashboardAnalytics.value.data.googlePlayMemberships).toLocaleString()}` : ''} - {$getDashboardAnalytics.value ? `${Math.trunc($getDashboardAnalytics.value.data.questsRewards).toLocaleString()}` : ''}</span>
                             </span>
                             {#if $getDashboardAnalytics.value && ($getDashboardAnalytics.value.data.memberships + $getDashboardAnalytics.value.data.googlePlayMemberships - $getDashboardAnalytics.value.data.questsRewards) !== 0 && ($getDashboardAnalytics.value.data.membershipsPreviousWeek + $getDashboardAnalytics.value.data.googlePlayMembershipsPreviousWeek - $getDashboardAnalytics.value.data.questsRewardsPreviousWeek) !== 0}
                             <br><span class="small red" class:loading={$getDashboardAnalytics.loading} class:audience-loading={$getDashboardAnalytics.loading} class:green={($getDashboardAnalytics.value.data.membershipsPreviousWeek + $getDashboardAnalytics.value.data.googlePlayMembershipsPreviousWeek - $getDashboardAnalytics.value.data.questsRewardsPreviousWeek) < ($getDashboardAnalytics.value.data.memberships + $getDashboardAnalytics.value.data.googlePlayMemberships - $getDashboardAnalytics.value.data.questsRewards)}>
                                 {$getDashboardAnalytics.value ? `${($getDashboardAnalytics.value.data.membershipsPreviousWeek + $getDashboardAnalytics.value.data.googlePlayMembershipsPreviousWeek - $getDashboardAnalytics.value.data.questsRewardsPreviousWeek) < ($getDashboardAnalytics.value.data.memberships + $getDashboardAnalytics.value.data.googlePlayMemberships - $getDashboardAnalytics.value.data.questsRewards) ? '+' : ''}${(($getDashboardAnalytics.value.data.memberships + $getDashboardAnalytics.value.data.googlePlayMemberships - $getDashboardAnalytics.value.data.questsRewards) * 100 / ($getDashboardAnalytics.value.data.membershipsPreviousWeek + $getDashboardAnalytics.value.data.googlePlayMembershipsPreviousWeek - $getDashboardAnalytics.value.data.questsRewardsPreviousWeek) - 100).toFixed(1)} %` : ""}
                             </span>
                             {/if}
                        </h3>
                    </div>
                </div>
            </div>
            
            <div class="col-lg-6 col-xxl-3">
                <div class="card widget-flat">
                    <div class="card-body">
                        <div class="float-end">
                            <div class="widget-icon">
                                <IconifyIcon icon={dollarIcon}/>
                            </div>
                        </div>
                        <h6 class="text-muted fw-normal mt-0">GP total sales</h6>
                        <h3 class="mt-3 mb-2">
                             <span class:loading={$getDashboardAnalytics.loading} class:audience-loading={$getDashboardAnalytics.loading}>
                                 {$getDashboardAnalytics.value ? `${Math.trunc($getDashboardAnalytics.value.data.googlePlay).toLocaleString()}` : ""}
                                 <span class="currency" class:dn={$getDashboardAnalytics.loading}>USD</span>
                             </span>
                             {#if $getDashboardAnalytics.value && $getDashboardAnalytics.value.data.googlePlay !== 0 && $getDashboardAnalytics.value.data.googlePlayPreviousWeek !== 0}
                             <br><span class="small red" class:loading={$getDashboardAnalytics.loading} class:audience-loading={$getDashboardAnalytics.loading} class:green={$getDashboardAnalytics.value.data.googlePlayPreviousWeek < $getDashboardAnalytics.value.data.googlePlay}>
                                 {$getDashboardAnalytics.value ? `${$getDashboardAnalytics.value.data.googlePlayPreviousWeek < $getDashboardAnalytics.value.data.googlePlay ? '+' : ''}${($getDashboardAnalytics.value.data.googlePlay * 100 / $getDashboardAnalytics.value.data.googlePlayPreviousWeek - 100).toFixed(1)} %` : ""}
                             </span>
                             {/if}
                        </h3>
                    </div>
                </div>
            </div>

            <div class="col-lg-6 col-xxl-3">
                <div class="card widget-flat">
                    <div class="card-body">
                        <div class="float-end">
                            <div class="widget-icon">
                                <IconifyIcon icon={dollarIcon}/>
                            </div>
                        </div>
                        <h6 class="text-muted fw-normal mt-0">GP memberships</h6>
                        <h3 class="mt-3 mb-2">
                             <span class:loading={$getDashboardAnalytics.loading} class:audience-loading={$getDashboardAnalytics.loading}>
                                 {$getDashboardAnalytics.value ? `${Math.trunc($getDashboardAnalytics.value.data.googlePlayMemberships).toLocaleString()}` : ""}
                                 <span class="currency" class:dn={$getDashboardAnalytics.loading}>LIS</span>
                             </span>
                             {#if $getDashboardAnalytics.value && $getDashboardAnalytics.value.data.googlePlayMemberships !== 0 && $getDashboardAnalytics.value.data.googlePlayMembershipsPreviousWeek !== 0}
                             <br><span class="small red" class:loading={$getDashboardAnalytics.loading} class:audience-loading={$getDashboardAnalytics.loading} class:green={$getDashboardAnalytics.value.data.googlePlayMembershipsPreviousWeek < $getDashboardAnalytics.value.data.googlePlayMemberships}>
                                 {$getDashboardAnalytics.value ? `${$getDashboardAnalytics.value.data.googlePlayMembershipsPreviousWeek < $getDashboardAnalytics.value.data.googlePlayMemberships ? '+' : ''}${($getDashboardAnalytics.value.data.googlePlayMemberships * 100 / $getDashboardAnalytics.value.data.googlePlayMembershipsPreviousWeek - 100).toFixed(1)} %` : ""}
                             </span>
                             {/if}
                        </h3>
                    </div>
                </div>
            </div>

            <div class="col-lg-6 col-xxl-3">
                <div class="card widget-flat">
                    <div class="card-body">
                        <div class="float-end">
                            <div class="widget-icon">
                                <IconifyIcon icon={dollarIcon}/>
                            </div>
                        </div>
                        <h6 class="text-muted fw-normal mt-0">GP products</h6>
                        <h3 class="mt-3 mb-2">
                             <span class:loading={$getDashboardAnalytics.loading} class:audience-loading={$getDashboardAnalytics.loading}>
                                 {$getDashboardAnalytics.value ? `${Math.trunc($getDashboardAnalytics.value.data.googlePlayProducts).toLocaleString()}` : ""}
                                 <span class="currency" class:dn={$getDashboardAnalytics.loading}>LIS</span>
                             </span>
                             {#if $getDashboardAnalytics.value && $getDashboardAnalytics.value.data.googlePlayProducts !== 0 && $getDashboardAnalytics.value.data.googlePlayProductsPreviousWeek !== 0}
                             <br><span class="small red" class:loading={$getDashboardAnalytics.loading} class:audience-loading={$getDashboardAnalytics.loading} class:green={$getDashboardAnalytics.value.data.googlePlayProductsPreviousWeek < $getDashboardAnalytics.value.data.googlePlayProducts}>
                                 {$getDashboardAnalytics.value ? `${$getDashboardAnalytics.value.data.googlePlayProductsPreviousWeek < $getDashboardAnalytics.value.data.googlePlayProducts ? '+' : ''}${($getDashboardAnalytics.value.data.googlePlayProducts * 100 / $getDashboardAnalytics.value.data.googlePlayProductsPreviousWeek - 100).toFixed(1)} %` : ""}
                             </span>
                             {/if}
                        </h3>
                    </div>
                </div>
            </div>

            <div class="col-lg-6 col-xxl-3">
                <div class="card widget-flat">
                    <div class="card-body">
                        <div class="float-end">
                            <div class="widget-icon">
                                <IconifyIcon icon={shoppingBag}/>
                            </div>
                        </div>
                        <h6 class="text-muted fw-normal mt-0">Marketplace volume</h6>
                        <h3 class="mt-3 mb-2">
                             <span class:loading={$getDashboardAnalytics.loading} class:audience-loading={$getDashboardAnalytics.loading}>
                                 {$getDashboardAnalytics.value ? `${Math.trunc($getDashboardAnalytics.value.data.marketplace.toLocaleString())}` : ""}
                                 <span class="currency" class:dn={$getDashboardAnalytics.loading}>USDT</span>
                             </span>
                             {#if $getDashboardAnalytics.value && $getDashboardAnalytics.value.data.marketplace !== 0 && $getDashboardAnalytics.value.data.marketplacePreviousWeek !== 0}
                             <br><span class="small red" class:loading={$getDashboardAnalytics.loading} class:audience-loading={$getDashboardAnalytics.loading} class:green={$getDashboardAnalytics.value.data.marketplacePreviousWeek < $getDashboardAnalytics.value.data.marketplace}>
                                 {$getDashboardAnalytics.value ? `${$getDashboardAnalytics.value.data.marketplacePreviousWeek < $getDashboardAnalytics.value.data.marketplace ? '+' : ''}${($getDashboardAnalytics.value.data.marketplace * 100 / $getDashboardAnalytics.value.data.marketplacePreviousWeek - 100).toFixed(1)} %` : ""}
                             </span>
                             {/if}
                        </h3>
                    </div>
                </div>
            </div>

            <div class="col-lg-6 col-xxl-3">
                <div class="card widget-flat">
                    <div class="card-body">
                        <div class="float-end">
                            <div class="widget-icon">
                                <IconifyIcon icon={shoppingBag}/>
                            </div>
                        </div>
                        <h6 class="text-muted fw-normal mt-0">Marketplace transactions count</h6>
                        <h3 class="mt-3 mb-2">
                             <span class:loading={$getDashboardAnalytics.loading} class:audience-loading={$getDashboardAnalytics.loading}>
                                 {$getDashboardAnalytics.value ? `${Math.trunc($getDashboardAnalytics.value.data.marketplaceCount.toLocaleString())}` : ""}
                                 <span class="currency" class:dn={$getDashboardAnalytics.loading}>N</span>
                             </span>
                             {#if $getDashboardAnalytics.value && $getDashboardAnalytics.value.data.marketplaceCount !== 0 && $getDashboardAnalytics.value.data.marketplaceCountPreviousWeek !== 0}
                             <br><span class="small red" class:loading={$getDashboardAnalytics.loading} class:audience-loading={$getDashboardAnalytics.loading} class:green={$getDashboardAnalytics.value.data.marketplaceCountPreviousWeek < $getDashboardAnalytics.value.data.marketplaceCount}>
                                 {$getDashboardAnalytics.value ? `${$getDashboardAnalytics.value.data.marketplaceCountPreviousWeek < $getDashboardAnalytics.value.data.marketplaceCount ? '+' : ''}${($getDashboardAnalytics.value.data.marketplaceCount * 100 / $getDashboardAnalytics.value.data.marketplaceCountPreviousWeek - 100).toFixed(1)} %` : ""}
                             </span>
                             {/if}
                        </h3>
                    </div>
                </div>
            </div>

            <div class="col-lg-6 col-xxl-3">
                <div class="card widget-flat">
                    <div class="card-body">
                        <div class="float-end">
                            <div class="widget-icon">
                                <IconifyIcon icon={coinsIcon}/>
                            </div>
                        </div>
                        <h6 class="text-muted fw-normal mt-0">Swap fees</h6>
                        <h3 class="mt-3 mb-2">
                             <span class:loading={$getDashboardAnalytics.loading} class:audience-loading={$getDashboardAnalytics.loading}>
                                 {$getDashboardAnalytics.value ? `${Math.trunc($getDashboardAnalytics.value.data.swapFees).toLocaleString()}` : ""}
                                 <span class="currency" class:dn={$getDashboardAnalytics.loading}>LIS</span>
                             </span>
                             {#if $getDashboardAnalytics.value && $getDashboardAnalytics.value.data.swapFees !== 0 && $getDashboardAnalytics.value.data.swapFeesPreviousWeek !== 0}
                             <br><span class="small red" class:loading={$getDashboardAnalytics.loading} class:audience-loading={$getDashboardAnalytics.loading} class:green={$getDashboardAnalytics.value.data.swapFeesPreviousWeek < $getDashboardAnalytics.value.data.swapFees}>
                                 {$getDashboardAnalytics.value ? `${$getDashboardAnalytics.value.data.swapFeesPreviousWeek < $getDashboardAnalytics.value.data.swapFees ? '+' : ''}${($getDashboardAnalytics.value.data.swapFees * 100 / $getDashboardAnalytics.value.data.swapFeesPreviousWeek - 100).toFixed(2)} %` : ""}
                             </span>
                             {/if}
                        </h3>
                    </div>
                </div>
            </div>
            
            <div class="col-xxl-12"><h6 class="section-title">AV Retention D7</h6></div>

            <div class="col-lg-6 col-xxl-3">
                <div class="card widget-flat">
                    <div class="card-body">
                        <div class="float-end">
                            <div class="widget-icon">
                                <IconifyIcon icon={chartIcon}/>
                            </div>
                        </div>
                        <h6 class="text-muted fw-normal mt-0">Cats</h6>
                        <h3 class="mt-3 mb-2">
                             <span class:loading={$getDashboardAnalytics.loading} class:audience-loading={$getDashboardAnalytics.loading}>
                                 {avgRetention['Cats']}
                                 <span class="currency" class:dn={$getDashboardAnalytics.loading}>%</span>
                                 {#if $getDashboardAnalytics.value}
                                    <br><span class="small retention" class:loading={$getDashboardAnalytics.loading} class:audience-loading={$getDashboardAnalytics.loading}>
                                        {$getDashboardAnalytics.value ? `${avgRetentionStartDate.format('MMM D')}-${avgRetentionStartDate.clone().add(6, 'days').format('MMM D')}` : ""}
                                    </span>
                                 {/if}
                             </span>
                        </h3>
                    </div>
                </div>
            </div>

            <div class="col-lg-6 col-xxl-3">
                <div class="card widget-flat">
                    <div class="card-body">
                        <div class="float-end">
                            <div class="widget-icon">
                                <IconifyIcon icon={chartIcon}/>
                            </div>
                        </div>
                        <h6 class="text-muted fw-normal mt-0">Dragons</h6>
                        <h3 class="mt-3 mb-2">
                             <span class:loading={$getRetentionAnalytics.loading} class:audience-loading={$getRetentionAnalytics.loading}>
                                {avgRetention['Dragons']}
                                 <span class="currency" class:dn={$getRetentionAnalytics.loading}>%</span>
                                 {#if $getRetentionAnalytics.value}
                                    <br><span class="small retention" class:loading={$getRetentionAnalytics.loading} class:audience-loading={$getRetentionAnalytics.loading}>
                                        {$getRetentionAnalytics.value ? `${avgRetentionStartDate.format('MMM D')}-${avgRetentionStartDate.clone().add(6, 'days').format('MMM D')}` : ""}
                                    </span>
                                 {/if}
                             </span>
                        </h3>
                    </div>
                </div>
            </div>

            <div class="col-lg-6 col-xxl-3">
                <div class="card widget-flat">
                    <div class="card-body">
                        <div class="float-end">
                            <div class="widget-icon">
                                <IconifyIcon icon={chartIcon}/>
                            </div>
                        </div>
                        <h6 class="text-muted fw-normal mt-0">Foxes</h6>
                        <h3 class="mt-3 mb-2">
                             <span class:loading={$getRetentionAnalytics.loading} class:audience-loading={$getRetentionAnalytics.loading}>
                                 {avgRetention['Foxes']}
                                 <span class="currency" class:dn={$getRetentionAnalytics.loading}>%</span>
                                 {#if $getRetentionAnalytics.value}
                                    <br><span class="small retention" class:loading={$getRetentionAnalytics.loading} class:audience-loading={$getRetentionAnalytics.loading}>
                                        {$getRetentionAnalytics.value ? `${avgRetentionStartDate.format('MMM D')}-${avgRetentionStartDate.clone().add(6, 'days').format('MMM D')}` : ""}
                                    </span>
                                 {/if}
                             </span>
                        </h3>
                    </div>
                </div>
            </div>

            <div class="col-lg-6 col-xxl-3">
                <div class="card widget-flat">
                    <div class="card-body">
                        <div class="float-end">
                            <div class="widget-icon">
                                <IconifyIcon icon={chartIcon}/>
                            </div>
                        </div>
                        <h6 class="text-muted fw-normal mt-0">Dogs</h6>
                        <h3 class="mt-3 mb-2">
                             <span class:loading={$getRetentionAnalytics.loading} class:audience-loading={$getRetentionAnalytics.loading}>
                                {avgRetention['Dogs']}
                                 <span class="currency" class:dn={$getRetentionAnalytics.loading}>%</span>
                                {#if $getRetentionAnalytics.value}
                                    <br><span class="small retention" class:loading={$getRetentionAnalytics.loading} class:audience-loading={$getRetentionAnalytics.loading}>
                                        {$getRetentionAnalytics.value ? `${avgRetentionStartDate.format('MMM D')}-${avgRetentionStartDate.clone().add(6, 'days').format('MMM D')}` : ""}
                                    </span>
                                 {/if}
                             </span>
                        </h3>
                    </div>
                </div>
            </div>
            
            <div class="col-xxl-12"><h6 class="section-title">AV Retention D1</h6></div>

            <div class="col-lg-6 col-xxl-3">
                <div class="card widget-flat">
                    <div class="card-body">
                        <div class="float-end">
                            <div class="widget-icon">
                                <IconifyIcon icon={chartIcon}/>
                            </div>
                        </div>
                        <h6 class="text-muted fw-normal mt-0">Cats</h6>
                        <h3 class="mt-3 mb-2">
                             <span class:loading={$getDashboardAnalytics.loading} class:audience-loading={$getDashboardAnalytics.loading}>
                                 {avgRetentionFirstDay['Cats']}
                                 <span class="currency" class:dn={$getDashboardAnalytics.loading}>%</span>
                                 {#if $getDashboardAnalytics.value}
                                    <br><span class="small retention" class:loading={$getDashboardAnalytics.loading} class:audience-loading={$getDashboardAnalytics.loading}>
                                        {$getDashboardAnalytics.value ? `${avgRetentionFirstDayStartDate.format('MMM D')}-${avgRetentionFirstDayStartDate.clone().add(6, 'days').format('MMM D')}` : ""}
                                    </span>
                                 {/if}
                             </span>
                        </h3>
                    </div>
                </div>
            </div>

            <div class="col-lg-6 col-xxl-3">
                <div class="card widget-flat">
                    <div class="card-body">
                        <div class="float-end">
                            <div class="widget-icon">
                                <IconifyIcon icon={chartIcon}/>
                            </div>
                        </div>
                        <h6 class="text-muted fw-normal mt-0">Dragons</h6>
                        <h3 class="mt-3 mb-2">
                             <span class:loading={$getRetentionAnalytics.loading} class:audience-loading={$getRetentionAnalytics.loading}>
                                {avgRetentionFirstDay['Dragons']}
                                 <span class="currency" class:dn={$getRetentionAnalytics.loading}>%</span>
                                 {#if $getRetentionAnalytics.value}
                                    <br><span class="small retention" class:loading={$getRetentionAnalytics.loading} class:audience-loading={$getRetentionAnalytics.loading}>
                                        {$getRetentionAnalytics.value ? `${avgRetentionFirstDayStartDate.format('MMM D')}-${avgRetentionFirstDayStartDate.clone().add(6, 'days').format('MMM D')}` : ""}
                                    </span>
                                 {/if}
                             </span>
                        </h3>
                    </div>
                </div>
            </div>

            <div class="col-lg-6 col-xxl-3">
                <div class="card widget-flat">
                    <div class="card-body">
                        <div class="float-end">
                            <div class="widget-icon">
                                <IconifyIcon icon={chartIcon}/>
                            </div>
                        </div>
                        <h6 class="text-muted fw-normal mt-0">Foxes</h6>
                        <h3 class="mt-3 mb-2">
                             <span class:loading={$getRetentionAnalytics.loading} class:audience-loading={$getRetentionAnalytics.loading}>
                                 {avgRetentionFirstDay['Foxes']}
                                 <span class="currency" class:dn={$getRetentionAnalytics.loading}>%</span>
                                 {#if $getRetentionAnalytics.value}
                                    <br><span class="small retention" class:loading={$getRetentionAnalytics.loading} class:audience-loading={$getRetentionAnalytics.loading}>
                                        {$getRetentionAnalytics.value ? `${avgRetentionFirstDayStartDate.format('MMM D')}-${avgRetentionFirstDayStartDate.clone().add(6, 'days').format('MMM D')}` : ""}
                                    </span>
                                 {/if}
                             </span>
                        </h3>
                    </div>
                </div>
            </div>

            <div class="col-lg-6 col-xxl-3">
                <div class="card widget-flat">
                    <div class="card-body">
                        <div class="float-end">
                            <div class="widget-icon">
                                <IconifyIcon icon={chartIcon}/>
                            </div>
                        </div>
                        <h6 class="text-muted fw-normal mt-0">Dogs</h6>
                        <h3 class="mt-3 mb-2">
                             <span class:loading={$getRetentionAnalytics.loading} class:audience-loading={$getRetentionAnalytics.loading}>
                                {avgRetentionFirstDay['Dogs']}
                                 <span class="currency" class:dn={$getRetentionAnalytics.loading}>%</span>
                                {#if $getRetentionAnalytics.value}
                                    <br><span class="small retention" class:loading={$getRetentionAnalytics.loading} class:audience-loading={$getRetentionAnalytics.loading}>
                                        {$getRetentionAnalytics.value ? `${avgRetentionFirstDayStartDate.format('MMM D')}-${avgRetentionFirstDayStartDate.clone().add(6, 'days').format('MMM D')}` : ""}
                                    </span>
                                 {/if}
                             </span>
                        </h3>
                    </div>
                </div>
            </div>
            
            <div class="col-xxl-12"><h6 class="section-title">Weekly active users</h6></div>

            <div class="col-lg-6 col-xxl-3">
                <div class="card widget-flat">
                    <div class="card-body">
                        <div class="float-end">
                            <div class="widget-icon">
                                <IconifyIcon icon={chartIcon}/>
                            </div>
                        </div>
                        <h6 class="text-muted fw-normal mt-0">Cats</h6>
                        <h3 class="mt-3 mb-2">
                             <span class:loading={$getActivityAnalytics.loading} class:audience-loading={$getActivityAnalytics.loading}>
                                {$getActivityAnalytics.value ? activity[3].toLocaleString() : ""}
                                {#if $getActivityAnalytics.value}
                                <br><span class="small activity red" class:loading={$getActivityAnalytics.loading} class:audience-loading={$getActivityAnalytics.loading} class:green={activity[3] > previousActivity[3]}>
                                    {$getActivityAnalytics.value ? `${previousActivity[3] < activity[3] ? '+' : ''}${(activity[3] * 100 / previousActivity[3] - 100).toFixed(1)} %` : ""}
                                </span>
                                {/if}
                             </span>
                        </h3>
                    </div>
                </div>
            </div>

            <div class="col-lg-6 col-xxl-3">
                <div class="card widget-flat">
                    <div class="card-body">
                        <div class="float-end">
                            <div class="widget-icon">
                                <IconifyIcon icon={chartIcon}/>
                            </div>
                        </div>
                        <h6 class="text-muted fw-normal mt-0">Dragons</h6>
                        <h3 class="mt-3 mb-2">
                             <span class:loading={$getActivityAnalytics.loading} class:audience-loading={$getActivityAnalytics.loading}>
                                {$getActivityAnalytics.value ? activity[5].toLocaleString() : ""}
                                {#if $getActivityAnalytics.value}
                                <br><span class="small activity red" class:loading={$getActivityAnalytics.loading} class:audience-loading={$getActivityAnalytics.loading} class:green={activity[5] > previousActivity[5]}>
                                    {$getActivityAnalytics.value ? `${previousActivity[5] < activity[5] ? '+' : ''}${(activity[5] * 100 / previousActivity[5] - 100).toFixed(1)} %` : ""}
                                </span>
                                {/if}
                             </span>
                        </h3>
                    </div>
                </div>
            </div>

            <div class="col-lg-6 col-xxl-3">
                <div class="card widget-flat">
                    <div class="card-body">
                        <div class="float-end">
                            <div class="widget-icon">
                                <IconifyIcon icon={chartIcon}/>
                            </div>
                        </div>
                        <h6 class="text-muted fw-normal mt-0">Foxes</h6>
                        <h3 class="mt-3 mb-2">
                             <span class:loading={$getActivityAnalytics.loading} class:audience-loading={$getActivityAnalytics.loading}>
                                {$getActivityAnalytics.value ? activity[7].toLocaleString() : ""}
                                {#if $getActivityAnalytics.value}
                                <br><span class="small activity red" class:loading={$getActivityAnalytics.loading} class:audience-loading={$getActivityAnalytics.loading} class:green={activity[7] > previousActivity[7]}>
                                    {$getActivityAnalytics.value ? `${previousActivity[7] < activity[7] ? '+' : ''}${(activity[7] * 100 / previousActivity[7] - 100).toFixed(1)} %` : ""}
                                </span>
                                {/if}
                             </span>
                        </h3>
                    </div>
                </div>
            </div>

            <div class="col-lg-6 col-xxl-3">
                <div class="card widget-flat">
                    <div class="card-body">
                        <div class="float-end">
                            <div class="widget-icon">
                                <IconifyIcon icon={chartIcon}/>
                            </div>
                        </div>
                        <h6 class="text-muted fw-normal mt-0">Dogs</h6>
                        <h3 class="mt-3 mb-2">
                             <span class:loading={$getActivityAnalytics.loading} class:audience-loading={$getActivityAnalytics.loading}>
                                {$getActivityAnalytics.value ? activity[11].toLocaleString() : ""}
                                {#if $getActivityAnalytics.value}
                                <br><span class="small activity red" class:loading={$getActivityAnalytics.loading} class:audience-loading={$getActivityAnalytics.loading} class:green={activity[11] > previousActivity[11]}>
                                    {$getActivityAnalytics.value ? `${previousActivity[11] < activity[11] ? '+' : ''}${(activity[11] * 100 / previousActivity[11] - 100).toFixed(1)} %` : ""}
                                </span>
                                {/if}
                             </span>
                        </h3>
                    </div>
                </div>
            </div>

            <div class="col-lg-6 col-xxl-3">
                <div class="card widget-flat">
                    <div class="card-body">
                        <div class="float-end">
                            <div class="widget-icon">
                                <IconifyIcon icon={chartIcon}/>
                            </div>
                        </div>
                        <h6 class="text-muted fw-normal mt-0">Global</h6>
                        <h3 class="mt-3 mb-2">
                             <span class:loading={$getActivityAnalytics.loading} class:audience-loading={$getActivityAnalytics.loading}>
                                {$getActivityAnalytics.value ? globalActivity['Current'].toLocaleString() : ""}
                                {#if $getActivityAnalytics.value}
                                <br><span class="small activity red" class:loading={$getActivityAnalytics.loading} class:audience-loading={$getActivityAnalytics.loading} class:green={globalActivity['Current'] >globalActivity['Previous']}>
                                    {$getActivityAnalytics.value ? `${globalActivity['Previous'] < globalActivity['Current'] ? '+' : ''}${(globalActivity['Current'] * 100 / globalActivity['Previous'] - 100).toFixed(1)} %` : ""}
                                </span>
                                {/if}
                             </span>
                        </h3>
                    </div>
                </div>
            </div>

            <div class="col-xxl-12"><h6 class="section-title">Monthly analytics</h6></div>

            <div class="col-xxl-12">
                <div class="card widget-flat">
                    <div class="card-body">
                        <Link to="/analytics/merge">
                            <h6 class="text-muted fw-normal mt-0" style="text-align: center;">LIS Saldo</h6>
                        </Link>
                        <Main onlyChart={true}/>
                    </div>
                </div>
            </div>
        </div>
    </svelte:fragment>
</MainLayout>

<style>
    .graphic {
        position: relative;
        height: 390px;
    }

    .graphic-loading {
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0;
        right: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #ffffff;
    }

    .dn {
        display: none;
    }

    .currency {
        font-size: 17px;
    }

    .small {
        font-size: 19px;
    }

    .small::after {
        content: 'vs. previous week';
        margin-left: 5px;
        font-size: 15px;
        color: #6c757d;
    }

    .memberships-payback {
        margin-left: 3px;
        font-size: 15px;
        color: #6c757d;
    }

    .small.activity::after {
        content: 'vs. previous 7 days';
    }

    .small.retention::after {
        display: none;
    }

    .small.retention {
        font-size: 16px;
    }

    .red {
        color: #e63e4f;
    }

    .green {
        color: #40b65c !important;
    }

    .loading.audience-loading {
        height: 34px;
        margin: 0;
    }

    .loading.audience-loading {
        height: 34px;
        width: 100px;
        vertical-align: top;
        display: inline-block;
    }

    .section-title {
        margin-bottom: 24px;
    }

    .card {
        position: relative;
        display: flex;
        flex-direction: column;
        min-width: 0;
        word-wrap: break-word;
        background: white;
        background-clip: border-box;
        border-radius: .25rem;
        border: none;
        box-shadow: 0 0 35px 0 rgba(154, 161, 171, 0.15);
        margin-bottom: 24px;
    }

    .widget-flat {
        position: relative;
        overflow: hidden;
    }

    .card-body {
        flex: 1 1 auto;
        padding: 1.5rem 1.5rem;
    }

    .widget-icon {
        font-size: 20px;
        background-color: rgba(230, 80, 0, 0.12);
        height: 40px;
        width: 40px;
        text-align: center;
        line-height: 37px;
        border-radius: 3px;
        display: inline-block;
        color: #FF5D1C;
    }

    h3 {
        font-size: 24px;
    }

    h6 small {
        background: #8391a230;
        border-radius: 4px;
        padding: 2px 5px;
        font-size: 12px;
        vertical-align: top;
    }

    input[type="date"] {
        font-size: 12px;
        padding: 3px;
        width: 120px;
        position: absolute;
        bottom: 1.5rem;
        right: 1.5rem;
    }

    @media(max-width: 991px) {
        .loading.audience-loading {
            height: 28px;
        }
    }
</style>
